import React, {Component} from "react";
import {Button, Col, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row,} from "reactstrap";


import assets from "../../util/assets";
import {getFormattedPrice} from "../../util/utility";

export default class RequestJoinAvailabilityModal extends Component {
    render() {

        const requestGroupType =
            this.props.request &&
            this.props.request.find((req) => {
                return req.request_type === "group";
            });

        const requestOneToOneType =
            this.props.request &&
            this.props.request.find((req) => {
                return req.request_type === "onetoone";
            });

        const requestAvailability = () => {
            this.props.requestAvailabilityBroadcast();
        };

        const sessionStyle = {
            sessionHead: {
                //height: "24px",
                //width: "109px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "18px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "24px",
                textAlign: "center",
            },
            sessionNameLeftText: {
                //height: "19px",
                //width: "97px",
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
            },
            sessionNameRightText: {
                //height: "19px",
                //width: "36px",
                color: "#1B75BC",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
            },
            sessionDescription: {
                //height: 34px,
                //width: 261px,
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "12px",
                letterSpacing: "0",
                lineHeight: "17px",
            },
            walletText: {
                //height: 19px,
                //width: 96px,
                color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "14px",
                letterSpacing: "0",
                lineHeight: "19px",
            },
            walletValue: {
                //height: 19px,
                //width: 44px,
                color: "#1B75BC",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "right",
            },
            creditLink: {
                //height: 19px,
                //width: 67px,
                color: "#1B75BC",
                fontFamily: "Open Sans",
                fontSize: "14px",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "center",
                textDecoration: "underline",
            },
            cancelButtonText: {
                //height: 19px,
                //width: 54px,
                // color: "#58595B",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "center",
            },
            requestButtonText: {
                //height: 19px,
                //width: 62px,
                color: "#FFFFFF",
                fontFamily: "Open Sans",
                fontSize: "14px",
                fontWeight: "600",
                letterSpacing: "0",
                lineHeight: "19px",
                textAlign: "center",
            },
            sessionBox: {
                padding: "10px",
            },
        };

        // Low Balance Alert (add credit || request button)
        let balanceAlert = false;
        const totalOfOneAndGroup =
            Number(this.props.allowOneToOne) + Number(this.props.groupSession);

        if (
            this.props.requestAvailabilityOneToOneSession &&
            this.props.requestAvailabilityGroupSession
        ) {
            Number(this.props.balance) < Number(totalOfOneAndGroup)
                ? (balanceAlert = true)
                : (balanceAlert = false);
        } else if (this.props.requestAvailabilityOneToOneSession) {
            Number(this.props.balance) < Number(this.props.allowOneToOne)
                ? (balanceAlert = true)
                : (balanceAlert = false);
        } else if (this.props.requestAvailabilityGroupSession) {
            Number(this.props.balance) < Number(this.props.groupSession)
                ? (balanceAlert = true)
                : (balanceAlert = false);
        }
        // -- / -- //

        return (
            <Modal
                isOpen={this.props.showAvailabilityModalFlag}
                toggle={() => this.props.hideRequestAvailabilityModal()}
                centered
            >
                <ModalHeader className="border-0 justify-content-center">
                    <div className="set-availability-modal"/>
                </ModalHeader>
                <ModalBody className="justify-content-center">
                    <h4 className="text-center mb-5" style={sessionStyle.sessionHead}>
                        Session type
                    </h4>
                    {this.props.allowOneToOne !== "N/A" ? (
                        <Row
                            className={
                                this.props.allowOneToOne == "N/A"
                                    ? "border border-secondary rounded m-2 disable-box-request-availability"
                                    : this.props.requestAvailabilityOneToOneSession
                                    ? "border border-secondary rounded m-2 selected-request-availability"
                                    : "border border-secondary rounded m-2 box-request-availability"
                            }
                            style={sessionStyle.sessionBox}
                            onClick={() =>
                                this.props.allowOneToOne !== "N/A" &&
                                this.props.updateRequestAvailabilityOneToOneSession()
                            }
                        >
                            <Col md="3" className="col-2 pr-0 pl-0">
                                <Row className="mx-2">
                                    <Col md="3" className="px-md-0 text-left">
                                        <Input
                                            type="checkbox"
                                            checked={requestOneToOneType || this.props.requestAvailabilityOneToOneSession}
                                            className="mx-md-0 mt-3"
                                            disabled={requestOneToOneType}
                                        />
                                    </Col>
                                    <Col md={{size: 6, offset: 1}} className="px-md-0">
                                        <img src={assets.one_to_one_icon_blue_bg} style={{width: "40px"}}/>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md="9" className="col-10 px-md-0 px-sm-1">
                                <Row>
                                    <Col md="8" className="col-6 text-left">
                    <span style={sessionStyle.sessionNameLeftText}>
                      1-on-1 Session
                    </span>
                                    </Col>
                                    <Col md="4" className="col-6 text-right">
                    <span
                        className="mr-md-2"
                        style={sessionStyle.sessionNameRightText}
                    >
                      {this.props.allowOneToOne === "Free"
                          ? this.props.allowOneToOne
                          : getFormattedPrice(this.props.allowOneToOne,true)}
                    </span>
                                    </Col>
                                </Row>
                                <Col md="12" className="px-0" style={{textAlign: "left"}}>
                  <span style={sessionStyle.sessionDescription}>
                    You can directly interact with broadcaster by sharing your
                    audio & video.
                  </span>
                                </Col>
                            </Col>
                        </Row>
                    ) : (
                        ""
                    )}

                    <Row
                        className={
                            this.props.requestAvailabilityGroupSession
                                ? "border border-secondary rounded m-2 selected-request-availability"
                                : "border border-secondary rounded m-2 box-request-availability"
                        }
                        style={sessionStyle.sessionBox}
                        onClick={() => this.props.updateRequestAvailabilityGroupSession()}
                    >
                        <Col md="3" className="col-2 pr-0 pl-0">
                            <Row className="mx-2">
                                <Col md="3" className="px-md-0  text-left">
                                    <Input
                                        type="checkbox"
                                        checked={requestGroupType || this.props.requestAvailabilityGroupSession}
                                        className="mx-md-0 mt-3"
                                        disabled={requestGroupType}
                                    />
                                </Col>
                                <Col md={{size: 6, offset: 1}} className="px-md-0">
                                    <img src={assets.group_icon_blue_bg} style={{width: "40px"}}/>
                                </Col>
                            </Row>
                        </Col>

                        <Col md="9" className="col-10 px-md-0 px-sm-1">
                            <Row>
                                <Col md="8" className="col-6 text-left">
                  <span style={sessionStyle.sessionNameLeftText}>
                    Group Session
                  </span>
                                </Col>
                                <Col md="4" className="col-6 text-right">
                  <span
                      className="mr-md-2"
                      style={sessionStyle.sessionNameRightText}
                  >
                    {this.props.groupSession === "Free"
                        ? this.props.groupSession
                        :getFormattedPrice(this.props.groupSession,true)}
                  </span>
                                </Col>
                            </Row>
                            <Col md="12" className="px-0" style={{textAlign: "left"}}>
                <span style={sessionStyle.sessionDescription}>
                  You can listen to broadcaster and also interact with
                  broadcaster via message.
                </span>
                            </Col>
                        </Col>
                    </Row>

                    <Row className="mt-4" style={{backgroundColor: "#F6F6F7"}}>
                        <Col md="6" className="col-6 text-leftpy-1">
                            <p className="pt-3">
                                <img src={assets.wallet} style={{width: "40px"}}/>
                                <span className="ml-2" style={sessionStyle.walletText}>
                  Wallet Balance
                </span>
                                <span className="ml-2" style={sessionStyle.walletValue}>
                  £{this.props.balance}
                </span>
                            </p>
                        </Col>
                        <Col md="6" className="col-6 text-right pt-3">
                            <a
                                href="javascript:void(0)"
                                onClick={() => {
                                    this.props.addBalance();
                                }}
                            >
                <span
                    style={sessionStyle.creditLink}
                    className={balanceAlert ? "text-danger" : ""}
                >
                  Add credit
                </span>
                            </a>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter className="border-0 justify-content-center pt-5">
                    <Row className="mx-5">
                        <Col>
                            <Button
                                outline
                                color="primary"
                                className="px-5"
                                onClick={() => {
                                    this.props.hideRequestAvailabilityModal();
                                    this.props.requestAvailabilityOneToOneSession &&
                                    this.props.updateRequestAvailabilityOneToOneSession();
                                    this.props.requestAvailabilityGroupSession &&
                                    this.props.updateRequestAvailabilityGroupSession();
                                }}
                            >
                                <span style={sessionStyle.cancelButtonText}>CANCEL</span>
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                color="primary"
                                className="px-5 text-capitalize"
                                onClick={() => requestAvailability()}
                                disabled={
                                    balanceAlert
                                        ? true
                                        : this.props.requestAvailabilityGroupSession ||
                                        this.props.requestAvailabilityOneToOneSession
                                        ? false
                                        : true
                                }
                            >
                                {this.props.availability.isFetching ? (
                                    <img
                                        src={assets.loading_white}
                                        alt={"Loading"}
                                        width={26}
                                        height={26}
                                    />
                                ) : (
                                    <span style={sessionStyle.requestButtonText}>REQUEST</span>
                                )}
                            </Button>
                        </Col>
                    </Row>
                </ModalFooter>
            </Modal>
        );
    }
}
